import React, { useEffect } from 'react';
import Animated from 'components/generals/AnimatedComponent';
import ContactInfoForm from 'components/generals/forms/info';
import image_1 from 'assets/images/home/section_15/img1.png';
import image_2 from 'assets/images/home/section_15/img2.png';
import image_3 from 'assets/images/home/section_15/img3.png';
import image_4 from 'assets/images/home/section_15/img4.png';
import image_5 from 'assets/images/home/section_15/img5.png';
import image_6 from 'assets/images/home/section_15/img6.png';
import { Image } from 'antd';
export default function Home__section__15() {
    return (
        <main className="nv__section nv__section--no-margin nv__hp__section__15">
            <section className="nv__section__container">
                <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                    <h1>Galeria</h1>
                </Animated>

                <Animated animation={'animate__fadeIn animate__delay-1s'}>
                    <section className="gallery__content">
                        <div className="gallery__content__item gallery__content__item--right">
                            <Image src={image_1} />
                        </div>
                        <div className="gallery__content__item gallery__content__item--left">
                            <div className="gallery__content__item__block">
                                <div className="gallery__content__item__block__element">
                                    <Image src={image_2} />
                                </div>
                                <div className="gallery__content__item__block__element gallery__content__item__block__element--left ">
                                    <Image src={image_3} />
                                </div>
                            </div>
                            <div className="gallery__content__item__block">
                                <div className="gallery__content__item__block__element gallery__content__item__block__element--small gallery__content__item__block__element--small--1">
                                    <Image src={image_4} />
                                </div>
                                <div className="gallery__content__item__block__element gallery__content__item__block__element--small gallery__content__item__block__element--small--2">
                                    <Image src={image_5} />
                                </div>
                                <div className="gallery__content__item__block__element gallery__content__item__block__element--small gallery__content__item__block__element--small--3">
                                    <Image src={image_6} />
                                </div>
                            </div>
                        </div>
                    </section>
                </Animated>
            </section>
        </main>
    );
}
